import React from "react";
import img1 from "../Assets/time.png";
import img2 from "../Assets/growth.png";
import img3 from "../Assets/dignity.png";
import img4 from "../Assets/doctors.png";
import "./joinmovement.css";
import { useNavigate } from "react-router-dom";
import { PROVIDER_URL } from "../../Service/AxiosConfig";
function JoinMovement() {
  const navigate = useNavigate();
  const handleJoin = () => {
    navigate("/join-wihan");
  };
  return (
    <div className="movement-container">
      <div className="left-content-m">
        <h2>Join the Movement</h2>
        <p className="sub">Be a CarePreneur. Earn with Purpose.</p>
        <p className="desc">
          Empower your career in care. Join India’s largest home healthcare
          professional network and unlock flexibility, dignity, and growth.
        </p>
        <button onClick={() => window.open( PROVIDER_URL, "_blank")} >Apply to Join Wihan</button>
        <div className="badge-row">
          <img src={img1} alt="Flexible Schedules" />
          <img src={img2} alt="Career Growth" />
          <img src={img3} alt="Dignity" />
        </div>
      </div>
      <div className="right-content-m">
        <img src={img4} alt="Doctors" />
      </div>
    </div>
  );
}

export default JoinMovement;
